import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1717570322091'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='1675'
        width='200'
        height='200'
    >
        <path
            d='M97 512.81c0-217.25 166.66-395.3 379.01-414.1 20.4 1.2 36.89 17.8 36.89 38.59 0 11.9-5.3 22.49-13.8 29.69-0.4 0.4 0 0.6 0.8 0.6-48.89 45.99-79.48 110.97-79.48 183.46 0 140.37 113.87 254.24 254.14 254.24 72.98 0 138.17-30.99 184.26-80.28 0.2 0.1 0.2 0.6 0.4 0.4 7.2-7.7 17.4-12.6 28.79-12.6 20.99 0 37.79 16.6 38.99 37.19-18.9 212.25-196.95 378.71-414.1 378.71-229.64 0-415.9-186.15-415.9-415.9z'
            p-id='1676'
            fill='currentColor'
        ></path>
    </svg>
)

export const DarkIcon = props => <Icon component={SVG} {...props} />
